import i18n from "@/language/i18n";

const DASHBOARD_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    DASHBOARD_MODULE_WINDOW_ID: 'dashboard',
});

export { DASHBOARD_MODULE_WINDOW_IDENTIFIER };

export default {
    DASHBOARD_GROUP_WRAPPER: {
        hidden: true,
        type: 'group',
        id: 'dashboard',
        label: i18n.t('ModuleRegistry.groups.dashboardManagement.name'),
        children: [],
        icon: '$wDashboard'
    },
    CHILDREN: {
        DASHBOARD_MODULE: {
            type: 'module',
            id: 'dashboard',
            windowIdentifierType: DASHBOARD_MODULE_WINDOW_IDENTIFIER.DASHBOARD_MODULE_WINDOW_ID,
            routerLink: '/dashboard',
        },
    }
}
